type StoreQrProps = {
  'aria-label': string;
};

function StoreQr({
  'aria-label': ariaLabel,
  store,
}: StoreQrProps & { store: 'ios' | 'android' }) {
  return (
    <img
      src={`/api/app/?store=${store}&qr=1`}
      width={132}
      height={132}
      alt={ariaLabel}
    />
  );
}

export const AppStoreHandoffQr = (props: StoreQrProps) => (
  <StoreQr {...props} store="ios" />
);

export const PlayStoreHandoffQr = (props: StoreQrProps) => (
  <StoreQr {...props} store="android" />
);
